/**
 * An honest placeholder. These sections are in the rail because they are the plan, and
 * this screen says plainly that they are not built — a console that fakes a feature
 * costs more trust than one that admits a gap.
 */
import { Shell } from "../components/Shell";
import { Eyebrow, Panel } from "../components/ui";

export function NotBuilt({ title, what, n }: { title: string; what: string; n: string }) {
  return (
    <Shell crumb={<span className="text-text">{title.toLowerCase()}</span>}>
      <div>
        <Eyebrow n={n}>roadmap</Eyebrow>
        <h2 className="mt-3 text-[2rem] leading-none tracking-tighter uppercase">{title}</h2>
      </div>
      <Panel title="not built yet">
        <div className="flex flex-col gap-3 px-4 py-8">
          <p className="max-w-[64ch] text-[13px] leading-relaxed text-dim">{what}</p>
          <p className="font-mono text-[10.5px] tracking-[0.14em] text-faint uppercase">
            &gt; specified in docs/superpowers/specs/2026-08-19-console-design.md
          </p>
        </div>
      </Panel>
    </Shell>
  );
}
